module.exports = __webpack_public_path__ + "media/assets/images/personas/claudio-5debf9dc59aaaef9e617e115bc818b85.jpg";